export default __webpack_public_path__ + "static/announce_b.139354fb47eafbbf113ad3dec60c97b1.png";